<template>
    <div class="content min-vh-100 flex-column d-flex justify-content-between">
        <section>
            <h2 class="title">
                CONTACT US
            </h2>
            <hr />
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <h3 class="text-md-center">HOW CAN WE HELP?</h3>
                    <p class="text-md-center">Please fill out the quick form and we will be in touch soon</p> 
                </div>
            </div>
            <form @submit.prevent="sendMessage">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="form-group">
                            <label for="select">To:</label>
                            <select class="form-control" :class="{ 'is-invalid': $v.form.to.$error }" v-model="form.to">
                                <option value="">Select</option>
                                <option v-for="option in toOptions" :value="option.value" :key="option.value">{{ option.label }}</option>
                            </select>
                            <div class="invalid-feedback" v-if="!$v.form.to.required">Field is required</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="form-group">
                            <label for="title">Subject:</label>
                            <input v-model="form.subject" type="text" class="form-control" :class="{ 'is-invalid': $v.form.subject.$error }" placeholder="Subject">
                            <div class="invalid-feedback" v-if="!$v.form.subject.required">Field is required</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="form-group">
                            <label for="message">Your message:</label>
                            <textarea v-model="form.message" type="text" class="form-control" :class="{ 'is-invalid': $v.form.message.$error }" rows="3"
                                max-rows="6">
                            </textarea>
                            <div class="invalid-feedback" v-if="!$v.form.message.required">Field is required</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="form-group">
                            <label for="title">Your mobile number:</label>
                            <input v-model="form.phone" type="text" class="form-control" :class="{ 'is-invalid': $v.form.phone.$error }"  placeholder="+39 123456789">
                            <div class="invalid-feedback" v-if="!$v.form.phone.required">Field is required</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="row-btn">
                            <button type="submit" class="btn btn-primary" >Send</button>
                        </div>
                    </div>
                </div>
            </form>
        </section>    
    </div>
</template>

<script>
import api from '../http/api.js'
import { required  } from 'vuelidate/lib/validators'

export default {
    data(){
        return {
            toOptions: [
                { value: "customer@ins4models.com", label: "Customer support"},
                { value: "claims@ins4models.com", label: "Claims information"}
            ],
            form: {
                to: "",
                subject: "",
                message: "",
                phone: this.$store.state.userInfo.phoneNumber, // default from anag
            }                      
        }
    },
    validations: {
        form: {
            to: {
                required,
            },
            subject: {
                required,
            },
            message: {
                required,
            },
            phone: {
                required,
            }
        }
    },
    methods: {
        sendMessage(){
            const v = this;

            this.$v.$touch()
            if (this.$v.$invalid) {
                return false;
            }

            const gcontact = { from: this.$store.state.userInfo.email, from_name: this.$store.state.userInfo.name,  ...this.form }

            api.post('/v1/mins/general-contact', gcontact)
                    .then(() => {
                        this.form = {
                            to: "",
                            subject: "",
                            message: "",
                            phone: "", 
                        };
                        v.$v.$reset();

                        this.$router.push({ name: 'GeneralContactsSuccess' });
                    })
                    .catch(() => {
                        //console.log(err);
                        v.$emit('show-message', {
                            type: 'danger',
                            text: "Oops! Something went wrong!"
                        });
                    });
        }
    }
}
</script>